<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="Export"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable :loadingTable="loading" colnum=7 :tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			loading: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			CusType() {
				return this.$store.state.MenusData.CusType;
			}
		},
		data: function() {
			return {
				rightboo: false,
				dwonleft: false,
				ptype: '',
				fromdataadd: [],
				fromdataedit: [],
				headerData: [{
						prop: 'VouCode',
						label: '经销商入库单号',
						columnwidth: 100
					},
					{
						prop: 'CusName',
						label: '入库方',
						columnwidth: 240
					},
					{
						prop: 'CusType',
						label: '入库方类型',
						columnwidth: 100
					},
					{
						prop: 'BusinessProvinceNames',
						label: '入库方经营省份',
						columnwidth: 100
					},
					{
						prop: 'VoucherType',
						label: '单据类型',
						columnwidth: 100
					},
					{
						prop: 'OCompanyName',
						label: '出库方',
						columnwidth: 100
					},
					{
						prop: 'StatusName',
						label: '状态',
						columnwidth: 100
					},
					{
						prop: 'CreateTime',
						label: '单据上传日期',
						columnwidth: 150
					},
					{
						prop: 'CreateYears',
						label: '单据创建年月',
						columnwidth: 100
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 100
					},
					{
						prop: "MFName",
						label: "生产厂商",
						columnwidth: 100
					}, {
						prop: "InvAddCode",
						label: "产品代码",
						columnwidth: 100
					}, {
						prop: "InvName",
						label: "产品名称",
						columnwidth: 100
					}, {
						prop: "Batch",
						label: "批号",
						columnwidth: 100
					}, {
						prop: "ManuDate",
						label: "生产日期",
						columnwidth: 100
					}, {
						prop: "ValiDate",
						label: "有效期至",
						columnwidth: 100
					}, {
						prop: "LEVEL1",
						label: "LEVEL1",
						columnwidth: 100
					}, {
						prop: "LEVEL2",
						label: "LEVEL2",
						columnwidth: 100
					}, {
						prop: "LEVEL3",
						label: "LEVEL3",
						columnwidth: 100
					}, {
						prop: "LEVEL4",
						label: "LEVEL4",
						columnwidth: 100
					}, {
						prop: "UnitName",
						label: "单位",
						columnwidth: 100
					}, {
						prop: "Quantity",
						label: "入库数量",
						columnwidth: 100
					}, {
						prop: "FUnitName",
						label: "辅助计量单位",
						columnwidth: 150
					}, {
						prop: "FQuantity",
						label: "辅助单位数量",
						columnwidth: 150
					}, {
						prop: "TaxUnitPrice",
						label: "含税单价",
						columnwidth: 100
					}, {
						prop: "TaxRate",
						label: "税率",
						columnwidth: 100
					}, {
						prop: "Money",
						label: "无税金额",
						columnwidth: 100
					}, {
						prop: "Sum",
						label: "价税合计",
						columnwidth: 100
					}, {
						prop: "StandardCost",
						label: "参考价格",
						columnwidth: 100
					}, {
						prop: "StandardSum",
						label: "参考价格合计",
						columnwidth: 120
					}, {
						prop: "SalesMan",
						label: "销售人员",
						columnwidth: 100
					}, {
						prop: "ProvinceMan",
						label: "省级经理",
						columnwidth: 200
					}, {
						prop: "AreaMan",
						label: "地区经理",
						columnwidth: 100
					}, {
						prop: "RegionMan",
						label: "大区经理",
						columnwidth: 100
					}, {
						prop: "CountryMan",
						label: "全国总监",
						columnwidth: 100
					}
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			if (this.CusType) {
				this.headerData.splice(28, 6);
				console.log('========>', this.CusType);
			}
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				let NodeID = this.$route.query.NodeID
				data.Menus.map((item, index) => {
					if (item.NodeID == NodeID) {
						this.qus = item.Nodes[index].Nodes
					}
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						}
					})
				}
			},
			Export() {
				this.$emit('Export')
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>